import { ConfigTreeNode } from '../models';
import { getRootConfigKey } from './getRootConfigKey';

/*
    The following threeLayerCase should look like the following diagram:
          ┌──────┐
          │ root │
          └──┬───┘
              │
          ┌───┴───┐
    ┌─────┤       ├────┐
    │  a  │       │ b  │
    └──┬──┘       └────┘
      │
    ┌──┴──┐
    │  a1 │
    └─────┘
 */
const rootStepConfig = {
  name: 'root',
  uses: ''
};
const aStepConfig = {
  name: 'a',
  uses: '',
  needs: {
    name: 'root'
  }
};
const a1StepConfig = {
  name: 'a1',
  uses: '',
  needs: {
    name: 'a'
  }
};
const bStepConfig = {
  name: 'b',
  uses: '',
  needs: {
    name: 'root'
  }
};

// expected tree nodes
const rootNode = {
  config: rootStepConfig,
  stepInstances: []
};

const aNode = {
  config: aStepConfig,
  stepInstances: [],
  parent: rootNode
};

const a1Node = {
  config: a1StepConfig,
  stepInstances: [],
  parent: aNode
};

const bNode = {
  config: bStepConfig,
  stepInstances: [],
  parent: rootNode
};

describe('getRootConfigKey()', () => {
  type SuccessCase = {
    name: string;
    map: Map<string, ConfigTreeNode>;
    expected?: string;
  };
  const threeLayerCase: SuccessCase = {
    name: 'when config tree is valid with multiple layers and branches',
    map: new Map([
      ['root', rootNode],
      ['a', aNode],
      ['a1', a1Node],
      ['b', bNode]
    ]),
    expected: 'root'
  };
  describe.each<SuccessCase>([threeLayerCase])('success: $name', ({ map, expected }) => {
    it(`should return correctly`, () => {
      const actual = getRootConfigKey(map);
      expect(actual).toEqual(expected);
    });
  });

  type FailureCase = {
    name: string;
    map: Map<string, ConfigTreeNode>;
    expectedError: string;
  };
  const noRootCase: FailureCase = {
    name: 'when config tree has no root node',
    map: new Map([
      ['a', aNode],
      ['a1', a1Node],
      ['b', bNode]
    ]),
    expectedError: 'Could not find root config'
  };
  describe.each<FailureCase>([noRootCase])('$name', ({ map, expectedError }) => {
    it(`should throw correct error`, () => {
      expect(() => getRootConfigKey(map)).toThrowError(expectedError);
    });
  });
});
